import { style } from '@mui/system';
import React, { useEffect, useRef, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { RegularMealDeadlines } from '../../etc/regularmealdeadline';
import { Link } from 'react-router-dom';
import styles from "../componentsStyle/restaurant.module.css";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { Socket } from 'socket.io-client';
import { Autocomplete, CircularProgress, FormControlLabel, FormHelperText, Radio, RadioGroup } from "@mui/material";

import { ReactComponent as Gargabe } from "../../svg/totalmenu/trash-solid.svg";


// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import StaticDatePicker from '@mui/lab/StaticDatePicker';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';

import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';



import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Meals from './controls/meals';
import Totalmeals from './controls/totalmeals';
import koLocale from 'date-fns/locale/ko'
import { AnyNsRecord } from 'dns';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { SportsRugbySharp } from '@mui/icons-material';
import TotalAppliedCharge from './controls/totalappliedcharge';
import ControlMoney from './controls/controlmoney';
import totalLocationData from '../../data/locationdata';
import { returnAccountInfo } from '../../data/locationFuntion';
import RestaurantMenuList from './controls/restaurantmenulist';
import RegularMeal from './controls/regularmeal/regularmeal';
import SubmitMeals2 from './controls/submitmeals2';
import RegularMealStatus from './controls/regularmeal/regularmealstatus';
import RegularMealStatusTotal from './controls/regularmeal/regularmealstatustotal';

type currentSideBarMenuList = "home" | "notification" | "alarm" | "edit" | "book" | "question" | "restaurant" | "envelope" | "search" | "chart" | "attendance" | "출석 관리 보고";

interface restaurantProps extends RouteComponentProps {
    activateMenuList: (curret: currentSideBarMenuList) => void;
    user: {
        name: string;
        value: "student" | "teacher" | "parent" | "staff";
        id: number;
        academy? : string;
        location? : string;
    } | undefined | null
    socket: Socket;
    isDionFoodUser?: boolean;
    regularMealSetting?: { price: number; isMenuVisible: boolean; deadlines: RegularMealDeadlines | null };
}


const Restaurant: React.FC<restaurantProps> = (props) => {

    const [loading, setLoading] = useState(false);
    const [mealLoading, setMealLoading] = useState(false);

    const [selectMenu, setSelectMenu] = useState("submit");
    //지점별 정기식 설정 (서버 주도 - 로그인 직후 dashboard.tsx에서 로드해 props로 전달됨)
    const regularMealSetting = props.regularMealSetting ? props.regularMealSetting : { price: 8000, isMenuVisible: false, deadlines: null };

    //노출 OFF 지점인데 정기식 탭이 선택되어 있으면 첫 탭으로 이동
    useEffect(() => {

        if (!regularMealSetting.isMenuVisible && selectMenu === "submit2") {
            setSelectMenu("submit");
        }

    }, [regularMealSetting.isMenuVisible]);

    const [restaurantList, setRestaurantList] = useState<any>();
    const [restaurantSelected, setRestaurantSelected] = useState<any>();

    const [openCharge, setOpenCharge] = useState(false);
    const [amount, setAmount] = useState(0);
    const [name, setName] = useState("");
    const [chargedAmount, setChargedAmount] = useState(0);
    const [chargePrev, setChargePrev] = useState(true);
    const [update, setUpdate] = useState(0);
    const [chargedBool, setChargedBool] = useState(false);

    const [uploadBool, setUploadBool] = useState(false);
    const [uploadBool2, setUploadBool2] = useState(false);

    const handleOpenCharge = () => setOpenCharge(true);
    const handleCloseCharge = () => setOpenCharge(false);
    const [openUpload, setOpenUpload] = React.useState(false);
    const [uploadRestaurantName, setUploadRestaurantName] = useState("");
    const [uploadMealName, setUploadMealName] = useState("");
    const [uploadMealPrice, setUploadMealPrice] = useState(0);
    const [uploadFile, setUploadFile] = useState();
    const [uploadFileName, setUploadFileName] = useState();

    const [uploadLoading, setUploadLoading] = useState(false);
    const [uploadLoading2, setUploadLoading2] = useState(false);

    const [submitLoading, setSubmitLoading] = useState(false);
    const [deadline, setDeadline] = useState<any>();

    const [lunchBool, setLunchBool] = useState(true);
    const [dinnerBool, setDinnerBool] = useState(true);

    const [dateValue, setDateValue] = useState(new Date());
    const [minDate, setMinDate] = useState();

    const [selectedMealName, setSelectedMealName] = useState("");
    const [selectedMealPrice, setSelectedMealPrice] = useState(0);
    const [selectedRestaurantName, setSelectedRestaurantName] = useState("");
    const [selectedMealId, setSelectedMealId] = useState(0);

    const [whenType, setWhenType] = useState<any>("lunch");

    const main = useRef<any>(null);

    const [mealMenu, setMealMenu] = useState<any>();

    const [lackOfBanlance, setLackOfBalance] = useState(false);
    const [duplicate, setDuplicate] = useState(false);
    const [timeOut, setTimeOut] = useState(false);
    const [success, setSuccess] = useState(false);
    const [nonSelect, setNonSelect] = useState(false);
    const [nonSelectMeal, setNonSelectMeal] = useState(false);

    const [mealList, setMealList] = useState<any>([]);
    const [selectedUploadMeal, setSelectedUploadMeal] = useState<any>(null);

    const [uploadDate, setUploadDate] = useState<any>(new Date());
    const [uploadLunchOrDinner, setUploadLunchOrDinner] = useState<any>("");

    const [location, setLocation] = useState("gangnam");


    const handleOpenUpload = () => setOpenUpload(true);
    const handleCloseUpload = () => setOpenUpload(false);

    const [open3, setOpen3] = useState(false);
    const handleOpen3 = () => {
        setOpen3(true);
    }
    const handleClose3 = () => {
        setOpen3(false);
    }

    useEffect(() => {

        console.log(props.user);
        console.log("user");

    }, [props.user]);

    useEffect(() => {

        props.activateMenuList("restaurant");
        if (props.user) {
            setName(props.user.name);
        }

        props.socket.on("newAmount", () => {
            const randomNumber = Math.floor(Math.random() * (99999 - 10000) + 10000);

            setUpdate(randomNumber);
        })

        //cleanup 없이 방문할 때마다 리스너가 누적되어 이벤트 1건에 재조회가 방문 횟수만큼 나가던 누수 수정
        return function cleanup() { props.socket.off("newAmount"); }

    }, []);

    const getInfo = async () => {
        var token = "";
        if (window.electron) {
            token = await window.electron.sendMessageApi.getToken();
        }

        

        fetch(`https://peetsunbae.com/dashboard/restaurant/start?dateValue=${new Date(dateValue).getTime()}&whenType=${whenType}`, {
            method: "GET",
            headers: { "Authorization": token },
            credentials: "include",
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    
                    setChargedAmount(result.amount ? result.amount : 0);
                    setMealMenu(result.meal ? result.meal : []);
                    setDeadline(result.deadline);
                    const array: any = [];
                    if (result.meal && result.meal.length > 0) {
                        setRestaurantSelected(result.meal[0].restaurantName);
                        result.meal.forEach((each: any) => {
                            array.push(each.restaurantName);
                        });
                        const set: any = new Set(array);
                        setRestaurantList([...set]);
                    }
                    setLoading(false);
                    setMealLoading(false);
                })
        })
    }


    //처음 시작 할때 메뉴랑 포인트 가져오는 기능----------------------------------------------
    useEffect(() => {


        setLoading(true);
        setRestaurantList([]);
        setSelectedMealName("");
        setSelectedMealPrice(0);
        setSelectedRestaurantName("");


        getInfo();

    }, [update, dateValue, whenType]);
    //----------------------------------------------------------------------------------------


    useEffect(() => {
        if (deadline) {
            const date = new Date();
            const currentTimeInfo = date.getHours() * 60 + date.getMinutes();
            const lunchDeadlineInfo = deadline.lunchHours * 60 + deadline.lunchMinutes;
            const dinnerDeadlineInfo = deadline.dinnerHours * 60 + deadline.dinnerMinutes;


            var clickedDate;
            if (dateValue) {
                clickedDate = new Date(dateValue);

            }
            
            

            if (clickedDate?.getMonth() === date.getMonth() && clickedDate.getDate() === date.getDate()) {
                if (currentTimeInfo <= lunchDeadlineInfo) {
                    
                    setLunchBool(true);
                    setDinnerBool(true);
                    // setWhenType("none");
                } else if (currentTimeInfo > lunchDeadlineInfo && currentTimeInfo <= dinnerDeadlineInfo) {
                    

                    setLunchBool(false);
                    setDinnerBool(true);
                    // setWhenType("none");
                    setWhenType("dinner");
                } else {
                    

                    setLunchBool(false);
                    setDinnerBool(false);
                }
            }
        }
    }, [deadline])

    const changeSelectedMenu = (e: any, type: string) => {
        switch (type) {
            case "submit": setSelectMenu("submit"); break;
            case "check": setSelectMenu("check"); break;
            case "total": setSelectMenu("total"); break;
            case "appliedCharge" : setSelectMenu("appliedCharge"); break;
            case "restaurantMenuList" : setSelectMenu("restaurantMenuList"); break;
            case "regularMeal" : setSelectMenu("regularMeal"); break;
            case "submit2": setSelectMenu("submit2"); break;
            case "regularTotal": setSelectMenu("regularTotal"); break;
        }
    }

    const handleChangeAmount = (e: any) => {
        const targetAmount = e.target.value;

        if (targetAmount && (+targetAmount > 0) && (+targetAmount) + (+chargedAmount) <= 100000) {
            setChargedBool(true);
        } else {
            setChargedBool(false);
        }

        setAmount(e.target.value);
    }

    const handleChangeName = (e: any) => {
        setName(e.target.value);
    }

    const handleChargePrev = async (e: any) => {
        setChargePrev(false);

        var token = "";
        if (window.electron) {
            token = await window.electron.sendMessageApi.getToken();
        }

        fetch("https://peetsunbae.com/dashboard/restaurant/charge", {
            method: "POST",
            headers: { "Authorization": token, "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
                amount: amount,
                name: name
            })
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    
                })
        })
    }

    const handleUploadRestaurantName = (e: any) => {
        setUploadRestaurantName(e.target.value);
        if (e.target.value && uploadMealName && +uploadMealPrice > 0 && uploadFile) {
            setUploadBool(true);
        }
    }

    const handleUploadMealName = (e: any) => {
        setUploadMealName(e.target.value);
        if (uploadRestaurantName && e.target.value && +uploadMealPrice > 0 && uploadFile) {
            setUploadBool(true);
        }
    }

    const handleUploadMealPrice = (e: any) => {
        setUploadMealPrice(e.target.value);
        if (uploadRestaurantName && uploadMealName && +e.target.value > 0 && uploadFile) {
            setUploadBool(true);
        }
    }

    //답변에 사진 올리기 기능-----------------------------------------------------------
    const fileOnChange = (event: any) => {
        if (event.target.files.length > 0) {
            if (uploadRestaurantName && uploadMealName && +uploadMealPrice > 0) {
                setUploadBool(true);
            }

            
            

            if (event.target) {
                setUploadFile(event.target.files[0]);
                setUploadFileName(event.target.files[0].name);
            }
        }
    }
    //-----------------------------------------------------------------------

    const deleteFile = (event: any) => {
        var VOID;
        setUploadFile(VOID);
        setUploadFileName(VOID);
        setUploadBool(false);
    }

    const uploadSubmit = (event: any) => {
        event.preventDefault();
        setUploadLoading(true);

        

        var formData = new FormData();
        var message = { restaurantName: uploadRestaurantName, mealName: uploadMealName, mealPrice: uploadMealPrice };
        formData.append("message", JSON.stringify(message));

        

        if (uploadFile) {
            formData.append("meal_picture", uploadFile);
        }

        

        var token = "";

        if (window.electron) {
            token = window.electron.sendMessageApi.getToken();
        }

        fetch("https://peetsunbae.com/dashboard/restaurant/write", {
            method: "POST",
            headers: { "Authorization": token },
            credentials: "include",
            body: formData
        }).then((response) => {
            response.json()
                .then((response) => {
                    
                    if (response.message === "success") {

                        setUploadLoading(false);
                        setUploadMealName("");
                        setUploadRestaurantName("");
                        setUploadMealPrice(0);
                        deleteFile(1);

                        const random = Math.floor(Math.random() * 999999);
                        setUpdate(random);
                    }
                })
        }).catch((error) => {
            
        })
    }

    const uploadSubmit2 = (event: any) => {
        event.preventDefault();

        setUploadLoading2(true);

        const data = {
            selectedUploadMeal, uploadDate, uploadLunchOrDinner, location
        }

        

        fetch("https://peetsunbae.com/dashboard/restaurant/registerMeal", {
            method: "POST",
            credentials: "include",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(
                data
            )
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    
                    if (result.message === "success") {
                        setUploadLoading2(false);
                        alert("업로드 성공");
                        setUpdate(Math.random());
                    }
                    if (result.message === "DUPLICATE") {
                        setUploadLoading2(false);
                        setUpdate(Math.random());
                        alert("해당 날짜에 중복된 메뉴가 이미 존재합니다.")
                    }
                })
        })
    }

    const selectedMenu = (e: any, name: string, price: number, restaurant: string, mealId: number) => {
        if (main.current) {
            main.current.scrollTo({ top: 200, behavior: "smooth" })
        }
        setSelectedMealName(name);
        setSelectedMealPrice(price);
        setSelectedRestaurantName(restaurant);
        setSelectedMealId(mealId);

    }

    const styleCharge = {
        borderRadius: "6px",
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
    };

    const styleUpload = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        p: 4,
    };

    const submitMeal = (forced : boolean = false) => {


        if (+chargedAmount < +selectedMealPrice) {
            
            setLackOfBalance(true);
            setTimeout(() => {
                setLackOfBalance(false);
            }, 1000)
        } else if (whenType === "none") {
            setNonSelect(true);
            setTimeout(() => {
                setNonSelect(false);
            }, 1000)
        } else if (!selectedMealName) {
            setNonSelectMeal(true);
            setTimeout(() => {
                setNonSelectMeal(false);
            }, 1000)
        } else if (dateValue) {

            if (!selectedMealPrice) {
                alert("음식 가격이 선택되지 않았습니다.");
                return;
            }

            if (!selectedMealId) {
                alert("음식이 선택되지 않았습니다.");
                return;
            }

            setSubmitLoading(true);

            const date = new Date(dateValue);


            var token = "";

            if (window.electron) {
                token = window.electron.sendMessageApi.getToken();
            }

            fetch("https://peetsunbae.com/dashboard/restaurant/order", {
                method: "POST",
                headers: { "Authorization": token, "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    targetYear: date.getFullYear(),
                    targetMonth: date.getMonth() + 1,
                    targetDate: date.getDate(),
                    whenType: whenType,
                    restaurantName: selectedRestaurantName,
                    mealName: selectedMealName,
                    price: selectedMealPrice,
                    mealId: selectedMealId,
                    forced
                })
            }).then((response) => {
                response.json()
                    .then((response) => {
                        setSubmitLoading(false);
                        
                        if (response.message === "TIME_OUT") {
                            setTimeOut(true);
                            setTimeout(() => {
                                setTimeOut(false);
                            }, 1500);
                        } else if (response.message === "LACK_BALANCE") {
                            setLackOfBalance(true);
                            setTimeout(() => {
                                setLackOfBalance(false);
                            }, 1500);
                        } else if (response.message === "success") {
                            setSuccess(true);
                            const randomNumber = Math.floor(Math.random() * (99999 - 10000) + 10000);
                            setUpdate(randomNumber);
                            setTimeout(() => {
                                setSuccess(false);
                            }, 1500);
                        } else if (response.message === "DUPLICATE") {
                            setDuplicate(true);
                            setTimeout(() => {
                                setDuplicate(false);
                            }, 1500);
                        }else if (response.message === "DUPLICATE2") {
                            if (window.confirm("해당 날짜에 정기식 주문이 있습니다. 그대로 진행하시겠습니까?")) {
                                submitMeal(true);
                            }
                        }
                    })
            }).catch((error) => {
                
            })


        }
    }

    const letsUpdate = () => {
        const random = Math.floor(Math.random() * 999999);
        setUpdate(random);
    }

    const disableWeekends = (date: any) => {
        return date.getDay() === 0;
    }

    useEffect(() => {
        getRegisteredMeals();
    }, [update]);

    const getRegisteredMeals = () => {

        fetch("https://peetsunbae.com/dashboard/restaurant/registeredTotalMeals", {
            method: "GET",
            credentials: "include"
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    
                    if (result.message === "success") {
                        const data = result.data;


                        const newMealList: any = [];

                        data.forEach((each: any) => {
                            const oneMeal: any = {};
                            oneMeal.id = each.id;
                            oneMeal.label = `[${each.restaurantName}] ${each.mealName}`;

                            newMealList.push(oneMeal);
                        })

                        setMealList([...newMealList]);


                    }
                })
        })

    }

    const handleChangeLunchOrDinner = (e: any) => {
        setUploadLunchOrDinner(e.target.value);
    }

    useEffect(() => {

        if (selectedUploadMeal && uploadDate && uploadLunchOrDinner) {
            setUploadBool2(true);
        } else {
            setUploadBool2(false);
        }

    }, [selectedUploadMeal, uploadDate, uploadLunchOrDinner]);


    //저녁 시간 지났을 때 내일로 바꾸기
    useEffect(() => {
        if (dinnerBool === false) {
            const today: any = new Date();
            today.setDate(today.getDate() + 1);
            setMinDate(today);
            setDateValue(today);
            setLunchBool(true);
            setDinnerBool(true);
        }

    }, [dinnerBool]);


    const letsTrash = async (selectedMealId: number) => {



        const message = "해당 도시락 메뉴를 삭제하시겠습니까?";

        if (window.confirm(message)) {
            

            setLoading(true);

            var token = "";

            if (window.electron) {
                token = await window.electron.sendMessageApi.getToken();
            }

            fetch(`https://peetsunbae.com/dashboard/restaurant/deletemeal`, {
                method: "DELETE",
                headers: { "Authorization": token, "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    selectedMealId
                })
            }).then((response: any) => {
                response.json()
                    .then((result: any) => {

                        if (result.message === "success") {
                            alert("도시락이 삭제되었습니다.");

                            letsUpdate();
                        }

                        setLoading(false);

                    })
            })

        } else {

        }

    }

    return (
        <div ref={main} className={styles.main}>

            <div className={styles.mainTitle}>
                <img className={styles.mainImg} src="img/restaurant.svg" /> 도시락 신청
            </div>

            <div className={styles.selectMenu}>
                <div onClick={(e) => { changeSelectedMenu(e, "submit") }} className={`selectedMenu ${selectMenu === "submit" ? "active" : ""}`}>
                    {
                        regularMealSetting.isMenuVisible
                        ?
                        "특식 신청하기"
                        :
                        "도시락 신청하기"
                    }
                </div>
                {
                    regularMealSetting.isMenuVisible &&
                    <div onClick={(e) => { changeSelectedMenu(e, "submit2") }} className={`selectedMenu ${selectMenu === "submit2" ? "active" : ""}`}>
                        정기식 신청하기
                    </div>
                }
                <div onClick={(e) => { changeSelectedMenu(e, "check") }} className={`selectedMenu ${selectMenu === "check" ? "active" : ""}`}>
                    나의 신청 현황
                </div>
                {
                    (props.user && (props.user.value === "teacher" || props.user.value === "staff") && !props.isDionFoodUser) &&
                    <div onClick={(e) => { changeSelectedMenu(e, "total") }} className={`selectedMenu ${selectMenu === "total" ? "active" : ""}`}>
                        전체 신청 현황
                    </div>
                }
                {
                    (props.user && (props.user.value === "teacher" || props.user.value === "staff") && (props.user?.academy?.includes("sunbae") || props.user?.academy?.includes("ubase")) || props.user?.academy?.includes("bundangsunbae")) &&
                    <div onClick={(e) => { changeSelectedMenu(e, "regularTotal") }} className={`selectedMenu ${selectMenu === "regularTotal" ? "active" : ""}`}>
                        정기식 신청 현황
                    </div>
                }
                {
                    (props.user && (props.user.value === "teacher" || props.user.value === "staff") && !props.isDionFoodUser) &&
                    <div onClick={(e) => { changeSelectedMenu(e, "appliedCharge") }} className={`selectedMenu ${selectMenu === "appliedCharge" ? "active" : ""}`}>
                        충전 신청 현황
                    </div>
                }
                {
                    (props.user && (props.user.value === "teacher" || props.user.value === "staff") && !props.isDionFoodUser) &&
                    <div onClick={(e) => { changeSelectedMenu(e, "restaurantMenuList") }} className={`selectedMenu ${selectMenu === "restaurantMenuList" ? "active" : ""}`}>
                        도시락 메뉴 관리
                    </div>
                }
                {
                    (props.user && (props.user.value === "teacher" || props.user.value === "staff") && (props.user.academy?.includes("sunbae")) || (props.user?.academy?.includes("ubase")) || (props.user?.academy?.includes("bundangsunbae"))) &&
                    <div onClick={(e) => { changeSelectedMenu(e, "regularMeal") }} className={`selectedMenu ${selectMenu === "regularMeal" ? "active" : ""}`}>
                        정기식 메뉴 넣기
                    </div>
                }
            </div>

            {/* {loading &&
                <div className={styles.loading}>
                    <CircularProgress />
                </div>
            } */}
            {(selectMenu === "submit") &&
                <>


                    <div className={styles.board}>

                        <div className={styles.schedule}>
                            <div className={styles.selectedMealMenu}>
                                - 선택메뉴 : <span>{selectedMealName}</span>
                            </div>
                            <div className={styles.calendarDiv}>
                                <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                                    <StaticDatePicker
                                        shouldDisableDate={disableWeekends}
                                        displayStaticWrapperAs="desktop"
                                        openTo="day"
                                        value={dateValue}
                                        disablePast
                                        minDate={minDate}
                                        onChange={(newValue: any) => {
                                            

                                            console.log(newValue.getFullYear(), newValue.getMonth(), newValue.getDate());
                                            setDateValue(newValue);
                                            const date = new Date(newValue);
                                            console.log(date.getFullYear(), date.getMonth(), date.getDate());
                                            const today = new Date();
                                            if (!(date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate())) {
                                                setLunchBool(true);
                                                setDinnerBool(true);
                                                // setWhenType("none");
                                            } else {
                                                if (deadline) {
                                                    const date = new Date();
                                                    const currentTimeInfo = date.getHours() * 60 + date.getMinutes();
                                                    const lunchDeadlineInfo = deadline.lunchHours * 60 + deadline.lunchMinutes;
                                                    const dinnerDeadlineInfo = deadline.dinnerHours * 60 + deadline.dinnerMinutes;

                                                    if (dateValue) {
                                                        const clickedDate = new Date(dateValue);

                                                    }

                                                    if (currentTimeInfo <= lunchDeadlineInfo) {
                                                        setLunchBool(true);
                                                        setDinnerBool(true);
                                                        // setWhenType("none");
                                                    } else if (currentTimeInfo > lunchDeadlineInfo && currentTimeInfo <= dinnerDeadlineInfo) {
                                                        setLunchBool(false);
                                                        setDinnerBool(true);
                                                        // setWhenType("none");
                                                    } else {
                                                        setLunchBool(false);
                                                        setDinnerBool(false);
                                                    }
                                                }
                                            }
                                        }}
                                        renderInput={(params: any) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            </div>



                            <div className={styles.submitDiv}>
                                <div className={styles.whenDiv}>
                                    <div className={`${styles.when} ${whenType === "lunch" ? styles.active : ""}  ${lunchBool ? "" : styles.disabled}`} onClick={(e: any) => { if (lunchBool) { setWhenType("lunch") } }}>
                                        점심
                                    </div>
                                    <div className={`${styles.when} ${whenType === "dinner" ? styles.active : ""} ${dinnerBool ? "" : styles.disabled}`} onClick={(e: any) => { if (dinnerBool) { setWhenType("dinner") } }}>
                                        저녁
                                    </div>
                                </div>
                                <div className={styles.priceDiv}>
                                    금액 : <span>{selectedMealPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원</span>
                                </div>

                                <div className={styles.alert}>
                                    {lackOfBanlance && <Alert severity="error"><span className={styles.alertSpan}>잔액이 부족합니다.</span></Alert>}
                                    {timeOut && <Alert severity="error"><span className={styles.alertSpan}>신청가능 시간이 지났습니다.</span></Alert>}
                                    {nonSelect && <Alert severity="error"><span className={styles.alertSpan}>점심/저녁 선택해주세요.</span></Alert>}
                                    {nonSelectMeal && <Alert severity="error"><span className={styles.alertSpan}>도시락을 선택해주세요.</span></Alert>}
                                    {duplicate && <Alert severity="error"><span className={styles.alertSpan}>이미 해당 시간에 도시락 주문을 하셨습니다.</span></Alert>}
                                    {success && <Alert severity="info"><span className={styles.alertSpan}>도시락 신청 성공</span></Alert>}
                                    {submitLoading && <div className="answerloading">
                                        <CircularProgress />
                                    </div>}
                                </div>

                                <div onClick={() => {submitMeal()}} className={styles.submitBtn}>
                                    신청하기 <img src="img/chevron-right-regular.svg" alt="chevronRight"></img>
                                </div>
                            </div>


                        </div>



                        <div className={styles.menu}>

                            <div className={styles.moneyCharge}>
                                <div>
                                    - 충전금 잔액 : <span className={styles.money}>{chargedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원</span>
                                </div>
                                <div onClick={handleOpenCharge} className={styles.handleChargeBtn}>
                                    충전하기 <img src="img/navigate_next_black_24dp.svg" alt="right" />
                                </div>
                            </div>

                            <div className={styles.restaurantList}>
                                {restaurantList && restaurantList.map((restaurant: string) => {
                                    return (
                                        <div key={Math.random()} onClick={(e) => { setRestaurantSelected(restaurant) }} className={`${styles.restaurant} ${restaurantSelected === restaurant ? styles.active : ""}`} data-restaurant={restaurant}>
                                            {restaurant}
                                        </div>
                                    )
                                })}
                            </div>

                            <div className={styles.mealMenuBoard}>
                                {
                                    loading &&
                                    <div className={styles.loading}>
                                        <CircularProgress />
                                    </div>

                                }
                                {
                                    (!loading && mealMenu) && mealMenu.map((menu: any, index: number) => {
                                        if (restaurantSelected === menu.restaurantName) {
                                            return (
                                                <div className={`${styles.eachMenu}`} key={Math.random()}>
                                                    <div className={styles.imgBox}>
                                                        <img className={styles.image} src={`https://peetsunbae.com/${menu.src.split("/public/")[1]}`}></img>
                                                        <div onClick={(e) => { selectedMenu(e, menu.mealName, menu.mealPrice, menu.restaurantName, menu.id) }} className={styles.mealSelect}>
                                                            <img className={styles.heart} src="img/heart.svg" alt="heart"></img>
                                                            <div className={styles.menuSelectText}>선택하기</div>
                                                        </div>
                                                    </div>
                                                    <div className={styles.menuTitle}>
                                                        {menu.mealName}
                                                    </div>
                                                    <div className={styles.menuPriceDiv}>
                                                        <span className={styles.menuPrice}>{menu.mealPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span> 원
                                                        {
                                                            (props.user && props.user.value === "teacher")
                                                            &&
                                                            <span className={styles.garbageDiv} onClick={() => { letsTrash(menu.selectedMealId); }}>
                                                                <Gargabe fill="black" style={{ width: "15px", marginLeft: "16px", cursor: "pointer" }} />
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })
                                }
                            </div>
                        </div>

                    </div>




                    {(props.user?.value === "teacher" || props.user?.value === "staff") &&
                        <div onClick={handleOpenUpload} className="qnaWrite">
                            <img src="./img/pencil.svg" alt="pencil" />
                            새로운 도시락 등록
                        </div>
                    }

                    {(props.user?.value === "teacher" || props.user?.value === "staff") &&
                        <div onClick={handleOpen3} className="qnaWrite2">
                            <img src="./img/pencil.svg" alt="pencil" />
                            도시락 등록
                        </div>
                    }



                    {/* 충전금 잔액 충전용 모달 */}
                    <Modal
                        open={openCharge}
                        onClose={handleCloseCharge}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={styleCharge}>


                            <div className={styles.chargeTitle}>
                                충전하기
                            </div>

                            {chargePrev &&
                                <>
                                    <div className={styles.chargeBoard}>
                                        <FormControl fullWidth>
                                            <div className={styles.chargeAmount}>충전금액</div>
                                            <OutlinedInput
                                                id="outlined-adornment-amount"
                                                value={amount}
                                                onChange={handleChangeAmount}
                                                startAdornment={<InputAdornment position="start">₩</InputAdornment>}
                                            />
                                            <FormHelperText>최대 보유 금액 100,000원</FormHelperText>
                                        </FormControl>

                                        <FormControl fullWidth>
                                            <div className={styles.chargeName}>입금자명</div>
                                            <OutlinedInput
                                                id="outlined-adornment-amount"
                                                value={name}
                                                onChange={handleChangeName}
                                            />
                                            <div style={{ fontSize: "0.75rem", marginTop: "3px", color: "rgba(0,0,0,0.6)", fontWeight: 400, lineHeight: 1.66, marginLeft: "14px" }}>
                                                실제 입금자명과 일치해야 반영됩니다.
                                            </div>
                                        </FormControl>


                                    </div>

                                    <div className={styles.chargeBtnDiv}>
                                        {chargedBool ?
                                            <div onClick={handleChargePrev} className={styles.chargeBtn}>
                                                충전하기
                                            </div>
                                            :
                                            <div className={styles.disabledChargedBtn}>
                                                충전하기
                                            </div>
                                        }

                                    </div>
                                </>
                            }
                            {!chargePrev &&
                                <>
                                    <div className={styles.accountInfoDiv}>
                                        <div className={styles.accountInfoTitle}>
                                            입금정보
                                        </div>
                                        <div className={styles.accountInfoDescription}>
                                            <div className={styles.accountInfoBank}>
                                                <div>
                                                    - 입금은행
                                                </div>
                                                <div>
                                                    {
                                                        (props.user && props.user.academy && props.user.location !== "대구점") &&
                                                        returnAccountInfo(props.user.academy).bank
                                                    }
                                                    {
                                                        (props.user && props.user.academy && props.user.location === "대구점") &&
                                                        returnAccountInfo("sunbaesha").bank
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.accountInfoNumber}>
                                                <div>
                                                    - 계좌번호
                                                </div>
                                                <div>
                                                    {
                                                        (props.user && props.user.academy && props.user.location !== "대구점") &&
                                                        returnAccountInfo(props.user.academy).account
                                                    }
                                                    {
                                                        (props.user && props.user.academy && props.user.location === "대구점") &&
                                                        returnAccountInfo("sunbaesha").account
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.accountInfoName}>
                                                <div>
                                                    - 예금주
                                                </div>
                                                <div>
                                                    {
                                                        (props.user && props.user.academy && props.user.location !== "대구점") &&
                                                        returnAccountInfo(props.user.academy).name
                                                    }
                                                    {
                                                        (props.user && props.user.academy && props.user.location === "대구점") &&
                                                        returnAccountInfo("sunbaesha").name
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.accountInfoAmount}>
                                                <div>
                                                    - 신청금액
                                                </div>
                                                <div>
                                                    {amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
                                                </div>
                                            </div>
                                            <div className={styles.accountInfoAddDesc}>
                                                <div>
                                                    - 입금자명
                                                </div>
                                                <div>
                                                    {name}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.accountInfoAdd}>
                                            - 30분안에 입금하시면 충전금 잔액에 반영됩니다.
                                        </div>
                                        <div className={styles.accountInfoAdd2}>
                                            - 실제 입금내역과 신청금액, 입금자명이 일치해야 반영됩니다.
                                        </div>
                                    </div>
                                </>
                            }
                        </Box>
                    </Modal>



                    {/* 도시락 업로드용 모달 */}
                    <Modal
                        open={openUpload}
                        onClose={handleCloseUpload}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={styleCharge}>

                            <form encType="multipart/formdata">

                                <div className={styles.chargeTitle}>
                                    새로운 도시락 등록
                                </div>

                                <div className={styles.chargeBoard}>


                                    <FormControl fullWidth>
                                        <div className={styles.chargeName}>업체명</div>
                                        <OutlinedInput
                                            id="outlined-adornment-amount"
                                            value={uploadRestaurantName}
                                            onChange={handleUploadRestaurantName}
                                        />
                                    </FormControl>

                                    <FormControl fullWidth>
                                        <div className={styles.chargeName}>도시락 이름</div>
                                        <OutlinedInput
                                            id="outlined-adornment-amount"
                                            value={uploadMealName}
                                            onChange={handleUploadMealName}
                                        />
                                    </FormControl>

                                    <FormControl fullWidth>
                                        <div className={styles.chargeAmount2}>가격</div>
                                        <OutlinedInput
                                            id="outlined-adornment-amount"
                                            value={uploadMealPrice}
                                            onChange={handleUploadMealPrice}
                                            startAdornment={<InputAdornment position="start">₩</InputAdornment>}
                                        />
                                    </FormControl>

                                    {
                                        uploadFile ?
                                            <div className="answerFile" style={{ marginTop: "16px" }}>
                                                <div className="answerFileTitle">
                                                    <img className="uploadedFileClip" src="img/paperclip-light.svg" alt="file" />
                                                    <div>{uploadFileName}</div>
                                                </div>
                                                <div>
                                                    <img onClick={deleteFile} className="uploadedFileTrash" src="img/trash-alt-light.svg" alt="config" />
                                                </div>
                                            </div> : ""
                                    }


                                    <div className={styles.uploadFileDiv}>
                                        <label htmlFor="file">
                                            <div className={styles.uploadFile}>
                                                <img className="clip" src="img/paperclip-light.svg" alt="file" /><span> 가로 세로 같은 사이즈 사진</span>
                                            </div>
                                        </label>
                                        <input onChange={(e) => fileOnChange(e)} type="file" name="file" id="file" accept="image/*" hidden />
                                    </div>


                                </div>

                                <div className={styles.chargeBtnDiv}>

                                    {uploadLoading ?
                                        <div className="answerloading">
                                            <CircularProgress />
                                        </div> : ""
                                    }
                                    {uploadBool ?
                                        <div onClick={uploadSubmit} className={styles.chargeBtn}>
                                            업로드
                                        </div>
                                        :
                                        <div className={styles.disabledChargedBtn}>
                                            업로드
                                        </div>
                                    }

                                </div>
                            </form>
                        </Box>
                    </Modal>

                    <Modal
                        open={open3}
                        onClose={handleClose3}
                    >
                        <Box
                            sx={styleCharge}
                        >
                            <div className={styles.chargeTitle}>
                                도시락 등록
                            </div>

                            <div className={styles.chargeBoard}>

                                <div className={styles.chargeName}>
                                    위치 선택
                                </div>
                                <RadioGroup
                                    row
                                    value={location}
                                    onChange={(event) => { setLocation(event.target.value); }}
                                >
                                    {/* <FormControlLabel value="gangnam" control={<Radio />} label="강남점" />
                                    <FormControlLabel value="daechi" control={<Radio />} label="대치점" />
                                    <FormControlLabel value="daechi2" control={<Radio />} label="대치3층" />
                                    <FormControlLabel value="daechi3" control={<Radio />} label="대치6층" /> */}
                                    {
                                        props.user && totalLocationData.filter(locationData => locationData.english !== "total").filter(locationData => 
                                            locationData.academy.includes(props.user?.academy || "")
                                        ).map((each, index) => {
                                            return (
                                                <FormControlLabel key={index} value={each.english} control={<Radio />} label={each.korean} />
                                            )
                                        })
                                    }
                                </RadioGroup>

                                <div className={styles.chargeName}>
                                    날짜 선택
                                </div>

                                <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        value={uploadDate}
                                        onChange={(newValue: any) => {
                                            setUploadDate(newValue);
                                        }}
                                        renderInput={(params: any) => <TextField fullWidth {...params} />}
                                    />
                                </LocalizationProvider>

                                <div className={styles.chargeName}>
                                    점심/저녁
                                </div>

                                <FormControl>
                                    <RadioGroup
                                        value={uploadLunchOrDinner}
                                        onChange={handleChangeLunchOrDinner}
                                        row>
                                        <FormControlLabel value="lunch" control={<Radio />} label="점심" />
                                        <FormControlLabel value="dinner" control={<Radio />} label="저녁" />
                                    </RadioGroup>
                                </FormControl>

                                <FormControl fullWidth>
                                    <div className={styles.chargeName}>도시락 선택</div>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={mealList}
                                        value={selectedUploadMeal}
                                        onChange={(event: any, newValue: any) => {
                                            setSelectedUploadMeal(newValue);
                                        }}
                                        fullWidth
                                        renderInput={(params: any) => <TextField {...params}
                                        />}
                                    />
                                </FormControl>

                                <div className={styles.chargeBtnDiv}>

                                    {uploadLoading2 ?
                                        <div className="answerloading">
                                            <CircularProgress />
                                        </div> : ""
                                    }
                                    {uploadBool2 ?
                                        <div onClick={uploadSubmit2} className={styles.chargeBtn}>
                                            업로드
                                        </div>
                                        :
                                        <div className={styles.disabledChargedBtn}>
                                            업로드
                                        </div>
                                    }

                                </div>

                            </div>
                        </Box>
                    </Modal>
                </>
            }
            {
                selectMenu === "submit2" && <SubmitMeals2 user={props.user} mealTicketPrice={regularMealSetting.price} regularMealDeadlines={regularMealSetting.deadlines} />
            }
            {
                selectMenu === "check" && <Meals letsUpdate={letsUpdate} regularMealDeadlines={regularMealSetting.deadlines} />
            }
            {
                selectMenu === "total" && <Totalmeals user={props.user} />
            }
            {
                selectMenu === "appliedCharge" && <ControlMoney user={props.user} />
            }
            {
                selectMenu === "restaurantMenuList" && <RestaurantMenuList />
            }
            {
                selectMenu === "regularMeal" && <RegularMeal user={props.user} />
            }
            {
                selectMenu === "regularTotal" && <RegularMealStatusTotal user={props.user} />
            }
        </div>
    )
}

export default Restaurant;